export default __webpack_public_path__ + "static/media/hollowArrow.3571dbad.svg";